import React, { useCallback } from 'react';
import { ErrorBoundary as ReactErrorBoundary, } from 'react-error-boundary';
import { FallbackError } from './FallbackError';
import { useLogErrorBoundary } from './hooks/useLogErrorBoundary';
export var ErrorBoundary = function (_a) {
    var children = _a.children, errorEventName = _a.errorEventName, onError = _a.onError, _b = _a.fallbackRender, fallbackRender = _b === void 0 ? undefined : _b, _c = _a.FallbackComponent, FallbackComponent = _c === void 0 ? FallbackError : _c;
    var logErrorBoundary = useLogErrorBoundary();
    var onErrorCallback = useCallback(function (error, errorInfo) {
        logErrorBoundary(error, errorInfo, errorEventName);
        if (onError) {
            onError(error, errorInfo);
        }
    }, [errorEventName, logErrorBoundary, onError]);
    // This looks a little ugly, but is due to how types are defined in
    // react-error-boundary.
    if (fallbackRender) {
        return (React.createElement(ReactErrorBoundary, { onError: onErrorCallback, fallbackRender: fallbackRender }, children));
    }
    if (FallbackComponent) {
        return (React.createElement(ReactErrorBoundary, { onError: onErrorCallback, FallbackComponent: FallbackComponent }, children));
    }
    // This case falls through to the next ErrorBoundary, which is why the default
    // FallbackComponent is set above.
    return (React.createElement(ReactErrorBoundary, { onError: onErrorCallback, fallback: null }, children));
};
//# sourceMappingURL=ErrorBoundary.js.map